import React, { CSSProperties } from 'react'

import { EmptyCircleImage } from '../empty-circle-image'
import { Icon, Image } from '../../../components/atoms'

export const ProfileImage = ({
  image,
  style,
  className,
}: {
  image?: string | undefined | null
  style?: CSSProperties
  className?: string
}) => {
  return image ? (
    <Image
      className={className}
      style={{ ...style }}
      src={image}
      alt=''
      type='cover'
      round
    />
  ) : (
    <EmptyCircleImage style={style} className={className}>
      <Icon name='user-filled' />
    </EmptyCircleImage>
  )
}
